module.exports = __webpack_public_path__ + "img/sieckFinesseAdaptation16.7716ab4e.png";